export default __webpack_public_path__ + "gap-icona4b257.png";